import request from '@/utils/request'

export function login(data) {
  return request({ url: '/auth/login', method: 'post', data, silent: true })
}

export function register(data) {
  return request({ url: '/auth/register', method: 'post', data })
}

export function getUserInfo() {
  return request({ url: '/auth/userinfo', method: 'get' })
}

export function changeOwnPassword(data) {
  return request({ url: '/auth/profile/password', method: 'put', data })
}

export function checkPermission(permissionCode) {
  return request({ url: '/auth/check-permission', method: 'get', params: { permissionCode } })
}

export function getDataOperations(resourceType) {
  return request({ url: '/auth/data-operations', method: 'get', params: { resourceType } })
}
